

import { getAuth } from "@firebase/auth";

export default defineNuxtRouteMiddleware((to, from) => {

  //console.log('Route:', to.path);
  //console.log('Host:', process.server ? useRequestHeaders(['host']) : window.location.host);

  const auth = getAuth()
  const claims = useState<Record<string, any>>('claims')

  const protectedRoutes = ['/admin', ]// add more routes here
  //'/data-deletion' 
  if (auth.currentUser) {
		console.log('user is signed in')
    // ignore
    if(to.path.includes('/admin') ) {
      if(claims.value?.admin === true || auth.currentUser.uid === 'THz8NyhPeAcok7JWc0De909sep62'){
        return;
      }
      return navigateTo( encodeURI('/error?message=no admin rights'))
    }
		return

  } else {
		// ceck if to.path starts with any protectRoutes
		if(protectedRoutes.some(route => 
			// check if route to.path contains route
			to.path.includes(route))){
			console.log('user is not signed in', to.path)
      return navigateTo('/login?redirect=' + to.path)
    }
  }
})